import { MotionProps } from "framer-motion";

export const fadeTransition: MotionProps = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.35 },
};
export const slideFromBottom: MotionProps = {
    initial: { y: 10 },
    animate: { y: 0 },
    exit: { y: 10 },
    transition: { duration: 0.5 },
};
export const mobileModalFade: MotionProps = {
    initial: { y: "100%" },
    animate: { y: 0 },
    exit: { y: "100%" },
    transition: { duration: 0.35, ease: ["easeInOut"] }
};
export const desktopModalFade: MotionProps = {
    initial: { x: "100vw" },
    animate: { x: 0, transition: { duration: 0.35, ease: ["easeOut"] } },
    exit: { x: "100vw", transition: { duration: .35, ease: ["easeIn"] } },
};
export const fadeScale: MotionProps = {
    initial: { scale: .85, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: .85, opacity: 0 },
    transition: { duration: 0.2 },
};
export const popupFade = (x: string = '-50%'): MotionProps => ({
    initial: { y: -20, opacity: 0, x },
    animate: { y: 0, opacity: 1, x },
    exit: { y: -20, opacity: 0, x },
    transition: {
        y: { duration: 0.25 }, opacity: { duration: 0.25 }, x: { duration: 0 }
    },
});
